export default __webpack_public_path__ + "static/media/logo-color.7cf1193e.svg";